module.exports = __webpack_public_path__ + "static/media/screentime.c5a38564.png";